import { FormApi } from 'final-form'
import { useEffect } from 'react'
import React from 'react'
import { Field, Form } from 'react-final-form'
import { FormProps } from 'react-final-form'

import { Go, Search } from '@cinch/oxd-components/icons/src'
import LoadingSpinner from '@cinch/oxd-components/loading-spinner/src'
import SVG from '@cinch/oxd-components/svg/src'
import { getAllUrlParams } from '@cinch/oxd-utils/browser-support/src'

import * as styles from './search-form.module.css'

export interface SearchProps extends Pick<FormProps, 'onSubmit'> {
  initialSearchValue?: string
  searchPending?: boolean
  i18n?: {
    search: string
    placeholder: string
  }
}

export const FORM_ID = 'search-form'
const BTN_SIZE_INPUTS = 26

const defaultTranslations = {
  search: 'Search',
  placeholder: 'Search by model, brand or vehicle type',
}

const SearchForm: React.FC<SearchProps> = ({
  searchPending,
  initialSearchValue = '',
  onSubmit,
  i18n = defaultTranslations,
}) => {
  const inputRef = React.createRef<HTMLInputElement>()

  useEffect(() => {
    const urlParams = getAllUrlParams()

    // eslint-disable-next-line no-prototype-builtins
    if (initialSearchValue && Object.keys(urlParams).length === 1 && !!urlParams.hasOwnProperty('query')) {
      onSubmit({ search: initialSearchValue }, (null as unknown) as FormApi)
    }
  }, [initialSearchValue])

  const onClickSubmit = (values: { [key: string]: any }, form: FormApi, callback?: (errors?: object) => void) => {
    const { search } = values as { [key: string]: any }
    const trimmedQuery = (search && search.trim()) || ''

    if (trimmedQuery.length === 0) {
      return Promise.resolve()
    }

    if (inputRef.current) {
      form.blur('search') // mark final form's internal state for the "search" field as blurred.
      inputRef.current.blur()
    }

    return onSubmit(values, form, callback)
  }

  return (
    <Form
      onSubmit={onClickSubmit}
      initialValues={{ search: initialSearchValue }}
      render={({ handleSubmit, invalid, submitting }) => (
        <div className={styles.search}>
          <form className={styles.wrapper} onSubmit={handleSubmit} id={FORM_ID}>
            <div className={styles.container}>
              <SVG children={Search} size={BTN_SIZE_INPUTS} hasGradient={true} className={styles.searchIcon} />
              <Field
                name="search"
                render={({ input }) => (
                  <input
                    {...input}
                    ref={inputRef}
                    type="search"
                    aria-label={i18n.placeholder}
                    placeholder={i18n.placeholder}
                    className={styles.input}
                  />
                )}
              />
              <button
                className={styles.goButton}
                title={i18n.search}
                type="submit"
                disabled={invalid || searchPending || submitting}
              >
                {searchPending && submitting ? (
                  <LoadingSpinner size={BTN_SIZE_INPUTS} />
                ) : (
                  <SVG children={Go} size={BTN_SIZE_INPUTS} hasGradient={true} />
                )}
              </button>
            </div>
          </form>
        </div>
      )}
    />
  )
}

export default SearchForm
